module.exports = __webpack_public_path__ + "img/2.8e49b9b2.svg";